import { useMutation } from '@tanstack/react-query';
import { socketAsFetch } from 'common/utils/socket-as-fetch';
import { MUTATION_KEYS, MESSAGE_TYPES } from 'common/constants';

export const useUpdateUserEmail = () =>
  useMutation({
    mutationKey: [MUTATION_KEYS.UPDATE_USER_EMAIL],
    mutationFn: async (variables: { emailAddress: string }) => {
      try {
        return await socketAsFetch({
          message_type: MESSAGE_TYPES.LINK_EMAIL,
          info: {
            email: variables.emailAddress,
          },
        });
      } catch (e) {
        // Rethrow as-is so the original stack and fields survive to Sentry.
        if (e instanceof Error) {
          throw e;
        }
        throw new Error("Failed to update the user's email", { cause: e });
      }
    },
  });
